import { Button } from '@mui/material';
import { FooterAction } from '../../interfaces';

type Props = {
  footerActions: FooterAction[];
};

export default function ModalFooter({ footerActions }: Props) {
  return (
    <div className="modal-footer">
      {footerActions.map(footerAction => (
        <Button onClick={footerAction.action} key={footerAction.label}>
          {footerAction.label}
        </Button>
      ))}
    </div>
  );
}
